module.exports = __webpack_public_path__ + "static/portsmouth.610ebbd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portsmouth.jpg
// module id = 480
// module chunks = 135683008411302